import { render } from "./TwoFactor.vue?vue&type=template&id=191a7c17&scoped=true"
import script from "./TwoFactor.vue?vue&type=script&lang=js"
export * from "./TwoFactor.vue?vue&type=script&lang=js"

import "./TwoFactor.vue?vue&type=style&index=0&id=191a7c17&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191a7c17"]])

export default __exports__